"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductTag;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireDefault(require("react"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
/* VENDOR */

/* LOCAL */

const TagButton = /*#__PURE__*/(0, _react.styled)("button")({
  name: "TagButton",
  class: "pl-thm1x2o",
  vars: {
    "thm1x2o-1": [({
      isActive
    }) => isActive ? _intents.default.ux.actionControl.backgroundColor : _intents.default.ux.box.backgroundColor],
    "thm1x2o-2": [({
      isActive
    }) => isActive ? `${_intents.default.ux.box.borderWidth} solid ${_intents.default.ux.actionChosen.borderColor}` : `${_intents.default.ux.box.borderWidth} solid ${_intents.default.ux.box.borderColor}`]
  }
});
const CountText = /*#__PURE__*/(0, _react.styled)("span")({
  name: "CountText",
  class: "pl-c1wgwyrt",
  vars: {
    "c1wgwyrt-0": [({
      isActive
    }) => isActive ? `${_intents.default.ux.feedbackHighContrastPremium.onFeedbackColor}` : `${_intents.default.ux.feedbackPassive.onFeedbackColor}`],
    "c1wgwyrt-1": [({
      isActive
    }) => isActive ? `${_intents.default.ux.feedbackHighContrastPremium.feedbackColor}` : `${_intents.default.ux.feedbackPassive.feedbackColor}`]
  }
});

/**
 * Render Tag.
 * @module Tag
 *
 * @param {object} props React props
 * @param {string} props.variant Tag variant
 * @param {number} props.count Counter for product tiles matching correlating tag
 * @param {string} props.id An unique identifier
 * @param {boolean} props.isActive Flag delineating active state
 * @param {string} props.label Tag label
 * @param {function} props.onClick Click handler
 * @returns {React.ReactElement} Tag component
 * @public
 */
function ProductTag({
  variant,
  count = 0,
  id,
  isActive = false,
  label,
  onClick,
  trackingCustomProperties = {}
}) {
  const renderCount = count !== null && typeof count !== 'undefined' && count > 0;
  switch (variant) {
    case 'filter':
      return /*#__PURE__*/_react2.default.createElement(TagButton, (0, _extends2.default)({
        id: `id-${id}`,
        onClick: onClick,
        isActive: isActive,
        "data-cy": "tag"
      }, _patternLibraryUtils.tracking.create(`tag_${label}`, true, false, trackingCustomProperties)), label, renderCount && /*#__PURE__*/_react2.default.createElement(CountText, {
        "data-cy": "tag-count",
        isActive: isActive
      }, count));
    default:
    case 'tile':
      return /*#__PURE__*/_react2.default.createElement(_tag.default, {
        text: label,
        design: "passive"
      });
  }
}
ProductTag.propTypes = {
  variant: _propTypes.default.oneOf(['filter', 'tile']),
  count: _propTypes.default.number,
  id: _propTypes.default.string,
  isActive: _propTypes.default.bool,
  label: _propTypes.default.string,
  onClick: _propTypes.default.func,
  trackingCustomProperties: _propTypes.default.object
};